(function () {
    angular
    .module('wizard', []);
})();
